import { combineReducers } from '@reduxjs/toolkit';
import { usersListReducer } from './reducers/users-list-reducer';
import { welldesignUsersListReducer } from './reducers/welldesign-list-reducer';
import { externalUsersRequestsReducer } from './reducers/external-users-requests';
import userDatasetSlice from './reducers/user-dataset.slice';
import type { IUsersState } from './interfaces';

export default combineReducers<IUsersState>({
  usersListReducer,
  welldesignUsersListReducer,
  userDatasetSlice,
  externalUsersRequestsReducer,
});
